import React from 'react'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import * as actions from '../Core/Game/game.actions'
import * as selectors from '../Core/Game/game.selectors'
import * as loaderSelectors from '../Core/Loader/loader.selectors'

import AudioContainer from '../Core/Game/AudioContainer'
import GameError from '../Core/Game/GameError'
import SceneContainer from '../Core/Game/SceneContainer'
import ScreensContainer from '../Core/Game/ScreensContainer'
import PopupsContainer from '../Core/Game/PopupsContainer'

import TutorialMessage from './Components/TutorialMessage'

import * as tutorialSelectors from './tutorial.selectors'
import TutorialModeMessage from './TutorialModeMessage'

/**
 *  Main game containerx
 *  Here live all other containers. Its main responsability is to control the
 *  scene change process and register/unregister resize event listener.
 */
class Game extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
  }
  /**
   *  After mount component
   */
  componentDidMount() {
    const { startResize } = this.props

    window.addEventListener(
      'resize',
      () => {
        startResize()
      },
      true
    )
  }

  /**
   *  Before unmount component
   */
  componentWillUnmount() {
    const { startResize } = this.props

    window.removeEventListener(
      'resize',
      () => {
        startResize()
      },
      true
    )
  }

  /**
   *  Universal onClick handler.
   */
  onClick(event) {
    const { broadcastUniversalClick } = this.props
    broadcastUniversalClick(event.target)
  }
  /**
   *  Universal onTouchStart handler.
   */
  onTouchStart(event) {
    const { broadcastUniversalTouch } = this.props
    broadcastUniversalTouch(event.target)
  }
  /**
   *  Universal onTouchStart handler.
   */
  onTouchEnd(event) {
    const { broadcastUniversalTouchEnd } = this.props
    broadcastUniversalTouchEnd(event.target)
  }

  onMouseDown(event) {
    const { broadcastUniversalMouseDown } = this.props
    broadcastUniversalMouseDown(event.target)
  }

  onMouseUp(event) {
    const { broadcastUniversalMouseUp } = this.props
    broadcastUniversalMouseUp(event.target)
  }

  onMouseLeave(event) {
    const { broadcastUniversalMouseLeave } = this.props
    broadcastUniversalMouseLeave(event.target)
  }

  Dropped(event) {
    const { broadcastUniversalDrop } = this.props

    broadcastUniversalDrop(event.target)
  }

  onDragEnd(event) {
    const { broadcastUniversalDragEnd } = this.props
    broadcastUniversalDragEnd(event.target)
  }
  /**
   *  Render component
   *  @return  {React.Component}  The component
   */
  render() {
    const { showingError, showTutorial } = this.props

    if (showingError) {
      return <GameError />
    }
    return (
      <div className="game-container">
        <div className="game-scene-container">
          <SceneContainer />
          <ScreensContainer />
          <PopupsContainer />
          {showTutorial && showTutorial.show && <TutorialMessage message={showTutorial.message} />}
          <TutorialModeMessage />
        </div>
        <AudioContainer />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  showingError: selectors.isShowingError(state),
  showingSceneTransition: selectors.isShowingSceneTransition(state),
  deviceInfo: selectors.getDevice(state),
  showingLoaderScreen: loaderSelectors.isLoading(state),
  progress: loaderSelectors.getProgress(state),
  showLoadingBar: loaderSelectors.getShowLoadingBar(state),
  showTutorial: tutorialSelectors.getTutorialMessage(state),
})

const mapDispatchToProps = (dispatch) => ({
  firstClickSignal: bindActionCreators(actions.firstClick, dispatch),
  broadcastUniversalClick: bindActionCreators(actions.broadcastUniversalClick, dispatch),
  broadcastUniversalTouchEnd: bindActionCreators(actions.broadcastUniversalTouchEnd, dispatch),
  broadcastUniversalMouseLeave: bindActionCreators(actions.broadcastUniversalMouseLeave, dispatch),
  broadcastUniversalTouch: bindActionCreators(actions.broadcastUniversalTouch, dispatch),
  broadcastUniversalMouseUp: bindActionCreators(actions.broadcastUniversalMouseUp, dispatch),
  broadcastUniversalMouseDown: bindActionCreators(actions.broadcastUniversalMouseDown, dispatch),
  broadcastUniversalDrop: bindActionCreators(actions.broadcastUniversalDrop, dispatch),
  broadcastUniversalDragEnd: bindActionCreators(actions.broadcastUniversalDragEnd, dispatch),
  startResize: bindActionCreators(actions.startResize, dispatch),
})

Game.propTypes = {
  broadcastUniversalClick: PropTypes.func,
  broadcastUniversalTouch: PropTypes.func,
  broadcastUniversalMouseLeave: PropTypes.func,
  broadcastUniversalTouchEnd: PropTypes.func,
  broadcastUniversalMouseUp: PropTypes.func,
  broadcastUniversalMouseDown: PropTypes.func,
  broadcastUniversalDrop: PropTypes.func,
  broadcastUniversalDragEnd: PropTypes.func,
  showingError: PropTypes.bool,
  startResize: PropTypes.func,

  showTutorial: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(Game)
